export function getErrorMessage(error: unknown, fallback = "Unknown error"): string {
  if (error instanceof Error) {
    return error.message
  }

  console.error("Unexpected non-Error thrown:", error)
  return fallback
}
